import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=8ed3d9d0&scoped=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed3d9d0",
  null
  
)

export default component.exports